import styled from "@emotion/styled";
import useUser from "@src/hook/useUser";
import { NextPage } from "next";
import { useRouter } from "next/router";
import TagManager from "react-gtm-module";
import Logo from "../../../Logo";
import { useState } from "react";
import { MarketingMenuBoardModal } from "../pc/MarketingMenuBoardModal";
import { apiServiceV2 } from "@src/api";

export interface MobileMenuProps {
	hidden?: boolean;
	pro?: boolean;
	onClose?: () => void;
}

const MainMobileMenu: NextPage<MobileMenuProps> = ({ hidden = true, pro = false, onClose }) => {
	const closeIcon = "/onepoint/assets/images/icon/close_pro.png";

	const router = useRouter();
	const { user } = useUser();

	const [menuBoardOpen, setMenuBoardOpen] = useState(false);

	const onClickLogin = () => {
		if (pro) {
			router.push("/signin?type=expert");
		} else {
			router.push("/signin?type=client");
		}
	};

	const onClickDashboard = () => {
		router.push("/match/my");
	};

	const onClickMenuBoard = () => {
		if (user.isLogin) {
			apiServiceV2.post("/utils/click-menu-board").catch((err) => console.error(err));
			window.open(
				"https://shrouded-meal-521.notion.site/2aff8567bbfa8029809bc906e4277307?v=2aff8567bbfa80218222000cad0af51c",
				"_blank",
			);
		} else {
			setMenuBoardOpen(true);
		}
	};

	return (
		<MobileMenuWrapper style={{ height: 0 }}>
			<div className={`mobile-menu-tab ${pro ? "mobile-expert" : ""}`}>
				<div className={`mobile-background ${hidden ? "hm-hidden" : ""}`}>
					<div className="head">
						<Logo pro={true} />
						<div className="h-close-wrap">
							<img
								className="menu-icon mob-menu-btn"
								src={closeIcon}
								alt="logo"
								onClick={onClose}
							/>
						</div>
					</div>
					<div className="hm-menu">
						<a
							href="https://featpaper.com/l/JemyuEY9"
							target="_blank"
							rel="noreferrer"
							onClick={() => {
								const tagManagerArgs = {
									dataLayer: {
										event: `client-menu-click`,
										to: "guide",
									},
								};
								TagManager.dataLayer(tagManagerArgs);
							}}
						>
							서비스 소개
						</a>
						<a
							href="https://1point.kr/blog"
							onClick={() => {
								const tagManagerArgs = {
									dataLayer: {
										event: `client-menu-click`,
										to: "blog",
									},
								};
								TagManager.dataLayer(tagManagerArgs);
							}}
						>
							블로그
						</a>
						<a
							href="https://1point.kr/blog/best-practices/"
							onClick={() => {
								const tagManagerArgs = {
									dataLayer: {
										event: `client-menu-click`,
										to: "best-practices",
									},
								};
								TagManager.dataLayer(tagManagerArgs);
							}}
						>
							성공 사례
						</a>
						<a href="/about">
							회사 소개
						</a>
						{!pro && (
							<div className="h-link client">
								<button
									style={{
										width: "fit-content",
										padding: "0 15px",
										backgroundColor: "#3D4148",
										color: "#fff",
										fontWeight: 800,
										fontSize: "12px",
										borderRadius: "25px",
										height: "40px",
										transition: "all 0.2s ease-in-out",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										gap: "6px",
										border: "none",
										whiteSpace: "nowrap",
									}}
									onClick={onClickMenuBoard}
								>
									마케팅 메뉴판 확인하기
									<span
										style={{
											backgroundColor: "#387cf6",
											color: "white",
											fontSize: "8px",
											fontWeight: 900,
											padding: "2px 4px",
											borderRadius: "4px",
											lineHeight: "1",
										}}
									>
										NEW
									</span>
								</button>
							</div>
						)}
						{!pro && (
							<div className="h-link client">
								<a
									href="https://notion.1point.kr/agency-matching"
									target="_blank"
									rel="noreferrer"
								>
									<button
										style={{
											width: "fit-content",
											padding: "0 15px",
											backgroundColor: "#fff",
											color: "#000",
											fontWeight: 800,
											borderRadius: "25px",
											height: "40px",
											transition: "all 0.2s ease-in-out",
											display: "flex",
											alignItems: "center",
											gap: "4px",
										}}
										onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#f0f5ff")}
										onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
									>
										탑티어 <span style={{ color: "#387cf6" }}>대행사</span>{" "}
										매칭받기
										<span
											style={{
												backgroundColor: "#387cf6",
												padding: "2px 4px",
												borderRadius: "4px",
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												marginLeft: "2px",
											}}
										>
											<span
												style={{
													fontWeight: "bold",
													color: "white",
													fontSize: "8px",
													lineHeight: "8px",
												}}
											>
												BETA
											</span>
										</span>
									</button>
								</a>
							</div>
						)}
						{user.isLogin ? (
							<div className="btn-login" onClick={onClickDashboard}>
								<button>대시보드</button>
							</div>
						) : (
							<div className="btn-login" onClick={onClickLogin}>
								<button>로그인하기</button>
							</div>
						)}
						<div className="h-link client">
							<a href={pro ? "/" : "/expert"}>
								<button>{pro ? "고객사이신가요?" : "전문가이신가요?"}</button>
							</a>
						</div>
					</div>
				</div>
			</div>
			<MarketingMenuBoardModal open={menuBoardOpen} onClose={() => setMenuBoardOpen(false)} />
		</MobileMenuWrapper>
	);
};
export default MainMobileMenu;

const MobileMenuWrapper = styled.div`
	.mobile-background {
		background-color: white;
		display: flex;
		flex-direction: column;
		width: 100%;
		top: 0;
		bottom: 0;
		left: 0;
		position: fixed;
		z-index: 10002;
		overflow-y: auto;
	}

	.btn-login {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		width: 150px;
		height: 40px;
		border-radius: 50px;
		background: var(--primary);
		transition: all 0.2s ease-in-out;
		cursor: pointer;

		&:hover {
			transform: scale(1.05);
		}

		button {
			font-size: 12px;
			font-weight: 700;
			color: #fff;
		}
	}

	.mobile-expert .mobile-background {
		background-color: white;
	}

	.hm-hidden {
		display: none;
	}

	.mobile-background .head {
		height: 75px;
		padding: 0 5%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		position: fixed;
		z-index: 1000;
		top: 0;
		left: 0;
	}

	.mobile-background .head {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 100px;
	}

	.h-close-wrap img {
		width: 24px;
		height: 24px;
	}

	.hm-menu {
		margin-top: 75px;
		display: flex;
		flex-direction: column;
		align-items: end;
		gap: 15px;
		padding: 0 5%;
	}

	.hm-menu a {
		color: var(--card-bg);
		font-size: 20px;
		font-weight: bold;
		font-family: "pretendard" !important;
		position: relative;

		.beta {
			position: absolute;
			top: 50%;
			left: -55px;
			transform: translateY(-50%);
			background-color: var(--primary);
			padding: 1px 8px;
			border-radius: 20px;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			margin-left: 3px;
			div {
				font-weight: bold;
				color: white;
				font-size: 14px;
				line-height: 20px;
				text-align: center;
			}
		}
	}

	.mobile-expert .hm-menu a {
		color: var(--card-bg);
	}

	button {
		border: none;
		background: transparent;
	}

	.hm-menu .h-link a button {
		border-radius: 25px;
		color: var(--card-bg);
		border: 1px solid var(--card-bg);
		width: 150px;
		height: 40px;
		font-size: 12px;
		font-weight: 500;
	}

	.mobile-expert .hm-menu .h-link a button {
		color: var(--card-bg);
		border: 1px solid #000;
	}

	.shortconsulting-box {
		display: inline-flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	.shortconsulting {
		margin-left: 10px;
		position: relative;
	}
`;
